"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
var actionTypes_1 = require("../actions/actionTypes");
var redux_form_1 = require("redux-form");
var formErrorsReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case actionTypes_1.FORM_ERROR_SET:
            var formErrorSetAction = action;
            return Object.assign({}, state, (_a = {}, _a[formErrorSetAction.name] = formErrorSetAction.formErrors, _a));
        case redux_form_1.actionTypes.DESTROY:
            var destroyAction = action;
            if (Object.keys(state).indexOf(destroyAction.meta.form[0]) !== -1) {
                //@ts-ignore
                var _b = state, _c = destroyAction.meta.form[0], _ = _b[_c], nextState = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
                return nextState;
            }
        default:
            return state;
    }
};
exports["default"] = formErrorsReducer;
